import { HTMLAttributes } from "react"
import styled from "styled-components"
import cn from "clsx"

const BodyTextTypography = styled.p`
  font-family: "Inter";
  font-style: normal;

  &.size-large {
    font-size: 18px;
    line-height: 22px;
  }

  &.size-medium {
    font-size: 16px;
    line-height: 20px;
  }

  &.size-semi-medium {
    font-size: 14px;
    line-height: 17px;
  }

  &.size-small {
    font-size: 12px;
    line-height: 16px;
  }

  &.size-xs {
    font-size: 10px;
    line-height: 14px;
  }

  &.weight-light {
    font-weight: 400;
  }

  &.weight-regular {
    font-weight: 500;
  }

  &.weight-semi-bold {
    font-weight: 600;
  }

  &.weight-bold {
    font-weight: 700;
  }

  &.color-success {
    color: ${(props) => props.theme.palette.success};
  }

  &.color-informative {
    color: ${(props) => props.theme.palette.informative};
  }

  &.color-error {
    color: ${(props) => props.theme.palette.error};
  }

  &.color-primary-dark {
    color: ${(props) => props.theme.palette.primary_one};
  }

  &.color-primary_alt_medium {
    color: ${(props) => props.theme.palette.secondary_three};
  }

  &.color-primary-alt-soft {
    color: ${(props) => props.theme.palette.secondary_four};
  }

  &.color-secondary-medium {
    color: ${(props) => props.theme.palette.secondary_medium};
  }

  &.color-gray-dark {
    color: ${(props) => props.theme.palette.text};
  }

  &.color-gray-medium {
    color: ${(props) => props.theme.palette.subtitle};
  }

  &.color-gray-light {
    color: ${(props) => props.theme.palette.disabled};
  }

  &.color-black {
    color: ${(props) => props.theme.palette.black};
  }

  &.color-white {
    color: ${(props) => props.theme.palette.white};
  }

  &.color-disabled {
    color: ${(props) => props.theme.palette.disabled};
  }

  &.fillWidth {
    width: 100%;
  }

  &.link {
    text-decoration-line: underline;
  }
`

export interface BodyTextProps extends HTMLAttributes<HTMLDivElement> {
  size?: "small" | "medium" | "large" | "xs" | "semi-medium"
  color?:
    | "success"
    | "informative"
    | "error"
    | "primary-dark"
    | "primary_alt_medium"
    | "primary-alt-soft"
    | "secondary-medium"
    | "gray-dark"
    | "gray-medium"
    | "gray-light"
    | "black"
    | "white"
    | "disabled"
  weight?: "light" | "regular" | "semi-bold" | "bold"
  fillWidth?: boolean
  link?: boolean
  className?: string
}

const BodyText = (props: BodyTextProps) => {
  const { size, color, weight = "light", fillWidth = false, link = false, className, ...rest } = props

  return (
    <BodyTextTypography
      className={cn(`size-${size}`, `color-${color}`, `weight-${weight}`, { fillWidth, link }, className)}
      {...rest}
    />
  )
}

export default BodyText
